import { useCallback, useState } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ProductDetail from '@univdiam/ui/customComponents/CatalogProduct/ProductDetail'
import { shareUrl } from '@univdiam/ui/lib/shareUrl'
import { useMutation, useQuery } from '@tanstack/react-query';
import api from '@/http/api';
import { useAuthStore } from '@/store';
type ProductImage = {
  src: string;
  alt: string;
  thumbnail?: string;
}
type BOMType = {
  "metal"?: string,
  "diamond"?: string,
  "price"?: string,
  "id": string,
  "size": string,
  "group": string,
  "shape": string,
  "ptr_wt": number,
  "subGroup": string,
  "subSubGroup": string,
  "no_of_stones": number,
  "total_weight": number
}

type CADType = {
  order_id?: string
  bom: string;
  attachments: string;
  selling_price: string;
  cost_price: string
  instruction: string
  notes?: string
  iFrameLink: string
}
type CADOrderType = {
  order_id?: string
  bom: string;
  price: string;
  instructions: string;
  cad_design_id: string;
  productId:string
}

const addCad = ({ order_id, attachments, bom, instruction,
  iFrameLink, notes }: CADType) => {
  return api.post(`/cad/create`, {
    order_id, attachments, bom, instruction,
    iFrameLink, notes
  });
}

const addCadOrderRequest = ({ order_id, bom, price, instructions, cad_design_id, productId }: CADOrderType) => {
  return api.post(`/cad_order_req/create`, {
    order_id, price, bom, instructions, cad_design_id, productId
  });
}

const getOrderCadSubmiited = (order_id: string) => {
  return api.get(`/cad_order_req/${order_id}`);
};

const ProductData = () => {
  const { id } = useParams()
  const { user } = useAuthStore()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const from = searchParams.get("from");
  const order_id = searchParams.get("order_id");
  const [filterdValue, setFilterdValue] = useState({})
  const location = useLocation();
  let currentCAD = location.state.metadata
  if (from === 'CAD') {
    currentCAD = location.state
  }

  const productImages: ProductImage[] = from === 'CAD' ? currentCAD.attachments : currentCAD.attachments.map((a: string, i: number) => (
    {
      src: a,
      alt: `Product Image ${i + 1}`,
      thumbnail: a
    }
  ))


  const BOM = currentCAD?.bom?.flatMap(item =>
    item?.variants?.map((variant: BOMType) => ({
      metal: item.metal,
      diamond: variant.diamond,
      price: variant.price
    }))
  ) as BOMType[]


  const { mutate, isPending } = useMutation({
    mutationFn: (values: CADType) => {
      // console.log('values', values)
      return addCad({ ...values, order_id: order_id! })
    },
    onSuccess: async () => {
      navigate(-1)
    }
  })

  const { mutate: createCADOrder } = useMutation({
    mutationFn: (values: CADOrderType) => {
      return addCadOrderRequest({ ...values, order_id: order_id!, productId:currentCAD.fileName  })
    },
    onSuccess: async () => {
      navigate(-1)
    }
  })

  const uniqueMetals = [...new Set(currentCAD.bom.map((item: BOMType) => item.metal))] as string[];

  const uniqueDiamonds = [...new Set(currentCAD.bom.map((item: BOMType) => item.diamond))] as string[];

  const filters = {
    diamond_quality: uniqueDiamonds,
    metal_type: uniqueMetals
  }

  const handleBack = () => {
    navigate(-1)
  }

  const generateShareLink = useCallback(async (params: { cad_design_id: string | number, share_data: Record<string, any> }) => {
    try {
      const res = await api.post('/cad/share', params)
      const shareCode = res?.data?.shareCode ?? res?.data?.token
      if (!shareCode) return null
      return shareUrl('share_product', shareCode, user?.business_name)
    } catch (err) {
      console.error('Failed to generate share link:', err?.response?.data || err)
      return null
    }
  }, [user])
  const { data: orderCadSubmitted } = useQuery({
    queryKey: ["order-cad-submitted", order_id],
    queryFn: async () => {
      return await getOrderCadSubmiited(order_id);
    },
    enabled: !!order_id,
  });
  const submittedOrders = orderCadSubmitted?.data?.cad_orders

  return (
    <div className='p-[16px]'>
      <ProductDetail filters={filters} productImages={productImages} from={from!} BOM={BOM} addCad={mutate} filterdValue={filterdValue} setFilterdValue={setFilterdValue} currentCAD={currentCAD} isPending={isPending} userBusinessName={user?.business_name} handleBack={handleBack} createCADOrder={createCADOrder} cadId={id} submittedOrders={submittedOrders} generateShareLink={generateShareLink} />
    </div>
  )
}

export default ProductData
